import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useResetPasswordApi } from '../../hooks/useResetPasswordApi';

export const useResetPassword = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createResetPassword } = useResetPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createResetPassword(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'OTP Verified Successfully', 'success');
      //   queryClient.invalidateQueries({
      //     queryKey: ['getChoices'],
      //     exact: false,
      //   });
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
